<template>
  <el-row :gutter="20">
    <el-col :span="24">
      <div class="grid-content bg-purple">
        <div class="main-center">
          <p>
            岳西友辰信息科技有限公司是移动互联网解决方案领域研究和开发的科技企业。前身为岳西立信计算机软件工作室。工作室成立时间为2011年3月29日。在教育科技、金融服务、共享科技、电子商务等方向上有着深厚的底蕴和丰富的经验。</p>
        </div>
      </div>
    </el-col>

  </el-row>

</template>

<script>
import Mast from '@/assets/mast.png'

export default {
  data () {
    return {
      mast: Mast
    }
  }
}
</script>

<style scoped>
  .grid-content {
    border-radius: 15px !important;
    height: 400px;
    font-size: 1.8em;
    line-height: 2em;
    text-align: center !important;
  }

  .bg-purple {
    background: #1F8CE5;
  }

  .main-center {
    margin-top: 40px;
    display:inline-block;
    text-align: left;
    color: white;
  }

  p {
    clear: both;
    text-indent: 2em;
    width: 30em;
  }

</style>
